import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { APP_CONFIG, AppConfig } from '@cco/apps/cco-frontend';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { Loader } from '@googlemaps/js-api-loader';

@Injectable()
export class GoogleMapsApiLoader {
  mapsApiLoaded = false;
  private loadStarted = false;
  private loadCompletedSource$ = new BehaviorSubject<boolean>(false);
  private loadComplete$ = this.loadCompletedSource$.pipe(filter(loaded => !!loaded));

  constructor(@Inject(APP_CONFIG) private config: AppConfig, private httpClient: HttpClient) {}

  load$(): Observable<boolean> {
    if (this.loadStarted) {
      return this.loadComplete$;
    }

    this.loadStarted = true;

    const loader = new Loader({
      apiKey: this.config.googleMapsApiKey,
    });

    Promise.all([
      loader.importLibrary('core'),
      loader.importLibrary('maps'),
      loader.importLibrary('places'),
      loader.importLibrary('geometry'),
    ]).then(() => {
      window['MarkerClusterer'] = MarkerClusterer;
      this.loadCompletedSource$.next(true);
    }).catch((err) => {
      Sentry.captureException(err, {
        fingerprint: [
          '{{ default }}',
          'google-maps-load-error',
        ],
      });
    });

    return this.loadComplete$;
  }
}
